import { action, observable, set } from "mobx";
import moment from "moment";
import Model from "~/models/Model";

class InvoicePayment extends Model {
  /**
   * @property {number|null}
   */
  @observable invoicePaymentLogId = null;

  /**
   * @property {number|null}
   */
  @observable invoiceId = null;

  /**
   * @property {number|null}
   */
  @observable creditCardId = null;

  /**
   * @property {number|null}
   */
  @observable amount = null;

  /**
   * @property {string|null}
   */
  @observable description = null;

  /**
   * @property {string|null}
   */
  @observable message = null;

  /**
   * @property {string|null}
   */
  @observable creationDts = null;

  /**
   * @property {string|null}
   */
  @observable modificationDts = null;

  /**
   * Set new data to our model
   * @override
   * @param {object} data
   */
  @action
  setData(data) {
    const { creationDts, modificationDts, ...rest } = data;
    set(this, rest);

    this.creationDts = creationDts ? moment.unix(creationDts) : null;
    this.modificationDts = modificationDts ? moment.unix(modificationDts) : null;
  }
}

export default InvoicePayment;
